import 'remixicon/fonts/remixicon.css';
import { Link, useParams, } from 'react-router-dom';
import { useAppSelector } from '../../store/Hooks';
import { Task } from '../../store/viewmodels/TaskViewModel';
import { getNextItemSetId } from '../../utils/TaskNavigationServices';
import { StudentData } from '../../store/viewmodels/StudentViewModel';
import TaskResults from './TaskResults';


interface TaskInfoProps {
    path: string
}

interface TaskInfoParams {
    taskId: string
}

function TaskInfo(props: TaskInfoProps) {

    let { taskId } = useParams<TaskInfoParams>();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    const tasks: Task[] = studentData.student.task_access_list; //If teacher needs to have access to taskList as well then we need a check here for which type of user is logged in

    let taskName: string = "";
    let taskTheme: string = "";
    let taskLink: string = "";
    let startTask: JSX.Element = <></>;
    if (tasks === undefined) return (<div></div>);
    let chosenTask: Task | undefined = tasks.find(task => task.id.toString() === taskId);
    if (chosenTask !== undefined) {
        taskTheme = chosenTask.theme;
        taskName = taskTheme !== "NONE" ? taskTheme : chosenTask.name;
        taskId = chosenTask.id.toString();

        let firstActiveItemSetId = getNextItemSetId(chosenTask, "", studentData.student.active_item_sets);

        taskLink = "/content/tasks/" + taskId;
        startTask = (
            <div className="hidden w-full my-1 py-1">
                <Link key={taskName + taskId} to={taskLink + "/itemsets/" + firstActiveItemSetId}>
                    <button key={taskName + taskId} type="button" className="w-full p-2 inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-teal-500 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <span className="ri-arrow-right-fill mr-2 text-xl text-bold"></span>
                        {"Aloita tehtävä"}
                    </button>
                </Link>
            </div>
        );
    }

    let returnB = (
        <div className="w-full my-1 py-1">
            <Link key={"tasksPage"} to={props.path}>
                <button key={taskName + taskId} type="button" className="w-full p-2 inline-flex items-center px-6 py-3 border border-transparent xl:text-lg 6xl:text-xl font-medium rounded-md shadow-sm text-white bg-teal-500 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <span className="ri-arrow-go-back-line mr-2 text-bold text-xl xl:text-2xl"></span>
                    {"Palaa tehtäviin"}
                </button>
            </Link>
        </div>

    );

    const taskResults = chosenTask !== undefined ? <TaskResults task={chosenTask} /> : <div></div>;

    return (
        <div className="p-8">
            <div>
                {taskResults}
                <div className="w-2/5 md:w-1/3 lg:w-1/4 xl:w-1/5">
                    {startTask}
                    {returnB}
                </div>
            </div>
        </div>
    );
}


export default TaskInfo;